import { render, staticRenderFns } from "./articleCenterDetail.vue?vue&type=template&id=579b242e&scoped=true&"
import script from "./articleCenterDetail.vue?vue&type=script&lang=js&"
export * from "./articleCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./articleCenterDetail.vue?vue&type=style&index=0&id=579b242e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b242e",
  null
  
)

export default component.exports